import api from '@/utils/api';

/**
 * Update CompanyProduct
 * @param {string} id Company id
 * @param {string} productId Product id
 * @param {object} data - The CompanyProduct data
 * @returns {Promise}
 */
const updateCompanyProductApi = (id, productId, data) =>
  api.patch(`/company/${id}/product/${productId}`, data);

export default updateCompanyProductApi;
